import axios from "axios";
import {useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-regular-svg-icons";

import "./wsi.css"

export default function WSI() {
    const [data, setData] = useState();

    useEffect(() => {
        axios.get("https://api-als2.nutramax.com/items/weekly_safety_inspection")
        .then( response => {
            setData(response.data.data);
        })
    }, [])
    return (
        <div id="wsi">
            {data? data.map(({ name, file, id}) =>  { return (
                <div key={id}>
                    <FontAwesomeIcon icon={faFile} color="gray"/>
                <a  href={`https://api-als2.nutramax.com/assets/${file}?download`} download={name} alt={name}> {name} </a>
                </div>
            )
            }): null}
            {data? console.log(data) : null}
        </div>
    )
}